
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9816"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9816"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("knCgR", function(module, exports) {

$parcel$export(module.exports, "MOTIF_RENDERERS", function () { return $ed63a473d62095c8$export$7aa0ede0afd07d3a; });

var $040sV = parcelRequire("040sV");
// Nine movements, in a Bauhaus vocabulary: circle, square, triangle, bold flat
// planes, heavy/thin stroke contrast, asymmetric balance. Two palette colours
// overlap at partial opacity so the translucency does the mixing, and a blurred
// bloom sits behind so the geometry lands on a field of colour rather than on
// bare paper.
//
// Each motif still answers "what is the prose doing here?", never "what is the
// prose about" — that distinction is the whole difference between a visual that
// belongs to an essay and clipart dropped on top of one.
const $ed63a473d62095c8$var$MID = (0, $040sV.BOX).height / 2;
/** An argument drawing to a point. Bars angle into a single disc. */ function $ed63a473d62095c8$var$converge(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width - 120,
        cy: $ed63a473d62095c8$var$MID,
        r: 96,
        opacity: 0.4
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 2.4,
        seed: 4
    });
    const bars = (0, $040sV.elementsFor)(intensity, 3, 6);
    const targetX = (0, $040sV.BOX).width - 132;
    for(let index = 0; index < bars; index += 1){
        const y = 34 + ((0, $040sV.BOX).height - 68) * index / Math.max(1, bars - 1);
        const height = 9 + index % 2 * 5;
        group.appendChild((0, $040sV.plane)('path', {
            d: `M40 ${(y - height / 2).toFixed(1)} L${targetX} ${($ed63a473d62095c8$var$MID - 5).toFixed(1)} ` + `L${targetX} ${($ed63a473d62095c8$var$MID + 5).toFixed(1)} L40 ${(y + height / 2).toFixed(1)} Z`,
            opacity: (0.22 + index % 3 * 0.14).toFixed(2)
        }, {
            order: index,
            from: 'left'
        }));
    }
    group.appendChild((0, $040sV.plane)('circle', {
        cx: targetX,
        cy: $ed63a473d62095c8$var$MID,
        r: 46,
        fill: (0, $040sV.ACCENT),
        opacity: 0.55
    }, {
        order: bars,
        from: 'scale'
    }));
    group.appendChild((0, $040sV.mark)('circle', {
        cx: targetX,
        cy: $ed63a473d62095c8$var$MID,
        r: 13
    }, {
        order: bars + 1
    }));
    return svg;
}
/** A tension splitting something open. A square broken along a hard diagonal. */ function $ed63a473d62095c8$var$fracture(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width / 2,
        cy: $ed63a473d62095c8$var$MID,
        r: 104,
        colour: (0, $040sV.ACCENT),
        opacity: 0.34
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 3.4,
        seed: 9
    });
    const gap = (0, $040sV.elementsFor)(intensity, 10, 30);
    const left = (0, $040sV.BOX).width / 2 - 104;
    const right = (0, $040sV.BOX).width / 2 + 104;
    group.appendChild((0, $040sV.plane)('path', {
        d: `M${left} 42 L${right - 40} 42 L${left + 52} ${(0, $040sV.BOX).height - 42} L${left} ${(0, $040sV.BOX).height - 42} Z`,
        transform: `translate(${-gap / 2} 0)`,
        opacity: 0.62
    }, {
        order: 0,
        from: 'left'
    }));
    group.appendChild((0, $040sV.plane)('path', {
        d: `M${right - 30} 42 L${right} 42 L${right} ${(0, $040sV.BOX).height - 42} L${left + 62} ${(0, $040sV.BOX).height - 42} Z`,
        transform: `translate(${gap / 2} 0)`,
        fill: (0, $040sV.ACCENT),
        opacity: 0.58
    }, {
        order: 1,
        from: 'right'
    }));
    const wedges = (0, $040sV.elementsFor)(intensity, 1, 3);
    for(let index = 0; index < wedges; index += 1)group.appendChild((0, $040sV.mark)('path', {
        d: (0, $040sV.trianglePath)((0, $040sV.BOX).width / 2, 76 + index * 54, 13, 180),
        opacity: (0.9 - index * 0.22).toFixed(2)
    }, {
        order: index + 2
    }));
    return svg;
}
/** Evidence building. Stacked bars, alternating weight, capped by a disc. */ function $ed63a473d62095c8$var$accumulate(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width - 130,
        cy: 96,
        r: 78,
        colour: (0, $040sV.ACCENT),
        opacity: 0.34
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 1.8,
        seed: 6
    });
    const columns = (0, $040sV.elementsFor)(intensity, 5, 10);
    const baseline = (0, $040sV.BOX).height - 44;
    const width = Math.min(30, ((0, $040sV.BOX).width - 100) / columns - 8);
    (0, $040sV.spread)(columns, 52).forEach((x, index)=>{
        const height = 24 + index / Math.max(1, columns - 1) * ((0, $040sV.BOX).height - 116);
        group.appendChild((0, $040sV.plane)('rect', {
            x: (x - width / 2).toFixed(1),
            y: (baseline - height).toFixed(1),
            width: width.toFixed(1),
            height: height.toFixed(1),
            fill: index % 2 ? (0, $040sV.ACCENT) : 'currentColor',
            opacity: index % 2 ? 0.5 : 0.72
        }, {
            order: index,
            from: 'bottom'
        }));
    });
    group.appendChild((0, $040sV.stroke)('path', {
        d: `M44 ${baseline} L${(0, $040sV.BOX).width - 44} ${baseline}`,
        'stroke-width': 3
    }, {
        length: (0, $040sV.BOX).width,
        order: 0
    }));
    group.appendChild((0, $040sV.mark)('circle', {
        cx: (0, $040sV.spread)(columns, 52).at(-1),
        cy: baseline - ((0, $040sV.BOX).height - 92) - 6,
        r: 15,
        fill: (0, $040sV.ACCENT)
    }, {
        order: columns
    }));
    return svg;
}
/** A claim thinning out. A solid plane dissolving into a shrinking grid. */ function $ed63a473d62095c8$var$erode(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: 110,
        cy: $ed63a473d62095c8$var$MID,
        r: 92,
        opacity: 0.4
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 4.2,
        seed: 12
    });
    const columns = (0, $040sV.elementsFor)(intensity, 7, 13);
    const rows = 3;
    group.appendChild((0, $040sV.plane)('rect', {
        x: 40,
        y: $ed63a473d62095c8$var$MID - 62,
        width: 74,
        height: 124,
        opacity: 0.74
    }, {
        order: 0,
        from: 'left'
    }));
    (0, $040sV.spread)(columns, 130).forEach((x, index)=>{
        const share = index / Math.max(1, columns - 1);
        const size = 26 * (1 - share * 0.72);
        const surviving = Math.max(1, Math.round((1 - share) * rows) + 1);
        for(let row = 0; row < surviving; row += 1){
            const y = $ed63a473d62095c8$var$MID + (row - (surviving - 1) / 2) * 46;
            group.appendChild((0, $040sV.plane)('rect', {
                x: (x - size / 2).toFixed(1),
                y: (y - size / 2).toFixed(1),
                width: size.toFixed(1),
                height: size.toFixed(1),
                fill: row % 2 ? (0, $040sV.ACCENT) : 'currentColor',
                opacity: (0.7 - share * 0.5).toFixed(2)
            }, {
                order: index,
                from: 'scale'
            }));
        }
    });
    return svg;
}
/** Crossing a line. A disc split by a bar, half in each colour. */ function $ed63a473d62095c8$var$threshold(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width / 2,
        cy: $ed63a473d62095c8$var$MID,
        r: 100,
        colour: (0, $040sV.COOL),
        opacity: 0.3
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 2,
        seed: 21
    });
    const radius = 62;
    const cx = (0, $040sV.BOX).width / 2;
    group.appendChild((0, $040sV.plane)('path', {
        d: `M${cx - radius} ${$ed63a473d62095c8$var$MID} A${radius} ${radius} 0 0 1 ${cx + radius} ${$ed63a473d62095c8$var$MID} Z`,
        opacity: 0.66
    }, {
        order: 0,
        from: 'up'
    }));
    group.appendChild((0, $040sV.plane)('path', {
        d: `M${cx + radius} ${$ed63a473d62095c8$var$MID} A${radius} ${radius} 0 0 1 ${cx - radius} ${$ed63a473d62095c8$var$MID} Z`,
        fill: (0, $040sV.ACCENT),
        opacity: 0.55
    }, {
        order: 1,
        from: 'bottom'
    }));
    group.appendChild((0, $040sV.plane)('rect', {
        x: 34,
        y: $ed63a473d62095c8$var$MID - 4,
        width: (0, $040sV.BOX).width - 68,
        height: 8,
        opacity: 0.9
    }, {
        order: 2,
        from: 'left'
    }));
    const crossings = (0, $040sV.elementsFor)(intensity, 1, 3);
    (0, $040sV.spread)(crossings + 2, 74).slice(1, crossings + 1).forEach((x, index)=>{
        group.appendChild((0, $040sV.mark)('path', {
            d: (0, $040sV.trianglePath)(x, $ed63a473d62095c8$var$MID - 34, 14, 0),
            fill: index ? (0, $040sV.ACCENT) : 'currentColor'
        }, {
            order: index + 3
        }));
    });
    return svg;
}
/** Rhythm, back and forth. Alternating half-discs on a baseline. */ function $ed63a473d62095c8$var$oscillate(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width / 2,
        cy: $ed63a473d62095c8$var$MID,
        r: 110,
        colour: (0, $040sV.ACCENT),
        opacity: 0.28
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 2.2,
        seed: 15
    });
    const lobes = (0, $040sV.elementsFor)(intensity, 4, 7);
    const radius = Math.min(42, ((0, $040sV.BOX).width - 80) / lobes / 2);
    (0, $040sV.spread)(lobes, 44 + radius).forEach((x, index)=>{
        const up = index % 2 === 0;
        const sweep = up ? 1 : 0;
        group.appendChild((0, $040sV.plane)('path', {
            d: `M${(x - radius).toFixed(1)} ${$ed63a473d62095c8$var$MID} A${radius.toFixed(1)} ${radius.toFixed(1)} 0 0 ${sweep} ${(x + radius).toFixed(1)} ${$ed63a473d62095c8$var$MID} Z`,
            fill: up ? 'currentColor' : (0, $040sV.ACCENT),
            opacity: up ? 0.66 : 0.52
        }, {
            order: index,
            from: up ? 'up' : 'bottom'
        }));
    });
    group.appendChild((0, $040sV.stroke)('path', {
        d: `M36 ${$ed63a473d62095c8$var$MID} L${(0, $040sV.BOX).width - 36} ${$ed63a473d62095c8$var$MID}`,
        'stroke-width': 2.5
    }, {
        length: (0, $040sV.BOX).width,
        order: 0
    }));
    return svg;
}
/** Circling something unresolved. Concentric rings, one square set askew. */ function $ed63a473d62095c8$var$orbit(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width / 2,
        cy: $ed63a473d62095c8$var$MID,
        r: 96,
        opacity: 0.36
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 1.6,
        seed: 30
    });
    const cx = (0, $040sV.BOX).width / 2;
    const rings = (0, $040sV.elementsFor)(intensity, 2, 4);
    group.appendChild((0, $040sV.plane)('rect', {
        x: cx - 54,
        y: $ed63a473d62095c8$var$MID - 54,
        width: 108,
        height: 108,
        transform: `rotate(45 ${cx} ${$ed63a473d62095c8$var$MID})`,
        fill: (0, $040sV.ACCENT),
        opacity: 0.3
    }, {
        order: 0,
        from: 'scale'
    }));
    for(let index = 0; index < rings; index += 1){
        const r = 34 + index * 26;
        group.appendChild((0, $040sV.stroke)('circle', {
            cx: cx,
            cy: $ed63a473d62095c8$var$MID,
            r: r,
            'stroke-width': index === 0 ? 5 : 1.5
        }, {
            length: Math.round(2 * Math.PI * r),
            order: index
        }));
    }
    group.appendChild((0, $040sV.mark)('circle', {
        cx: cx + 34 + (rings - 1) * 26,
        cy: $ed63a473d62095c8$var$MID,
        r: 12,
        fill: (0, $040sV.ACCENT)
    }, {
        order: rings
    }));
    return svg;
}
/** A system or structure. The Bauhaus grid: some cells filled, some open. */ function $ed63a473d62095c8$var$lattice(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width / 2,
        cy: $ed63a473d62095c8$var$MID,
        r: 104,
        colour: (0, $040sV.COOL),
        opacity: 0.3
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 1.4,
        seed: 44
    });
    const columns = (0, $040sV.elementsFor)(intensity, 4, 7);
    const rows = 3;
    const cell = Math.min(46, ((0, $040sV.BOX).width - 96) / columns);
    const originX = ((0, $040sV.BOX).width - cell * columns) / 2;
    const originY = $ed63a473d62095c8$var$MID - cell * rows / 2;
    for(let column = 0; column < columns; column += 1)for(let row = 0; row < rows; row += 1){
        // A regular alternation, broken often enough to stay a composition.
        const filled = (column + row * 2) % 3 === 0;
        const accent = column * row % 4 === 1;
        group.appendChild((0, $040sV.plane)('rect', {
            x: (originX + column * cell).toFixed(1),
            y: (originY + row * cell).toFixed(1),
            width: cell.toFixed(1),
            height: cell.toFixed(1),
            fill: filled ? accent ? (0, $040sV.ACCENT) : 'currentColor' : 'none',
            stroke: 'currentColor',
            'stroke-width': filled ? 0 : 1.4,
            opacity: filled ? accent ? 0.5 : 0.66 : 0.4
        }, {
            order: column + row,
            from: 'scale'
        }));
    }
    return svg;
}
/** Narrowing or opening. An iris of triangular segments around an open centre. */ function $ed63a473d62095c8$var$aperture(intensity) {
    const svg = (0, $040sV.svgRoot)();
    (0, $040sV.bloom)(svg, {
        cx: (0, $040sV.BOX).width / 2,
        cy: $ed63a473d62095c8$var$MID,
        r: 92,
        colour: (0, $040sV.ACCENT),
        opacity: 0.34
    });
    const group = (0, $040sV.organic)(svg, {
        strength: 2.6,
        seed: 51
    });
    const cx = (0, $040sV.BOX).width / 2;
    const blades = (0, $040sV.elementsFor)(intensity, 4, 8);
    for(let index = 0; index < blades; index += 1){
        const angle = 360 / blades * index;
        group.appendChild((0, $040sV.plane)('path', {
            d: `M${cx} ${$ed63a473d62095c8$var$MID - 96} L${cx + 40} ${$ed63a473d62095c8$var$MID - 40} L${cx - 40} ${$ed63a473d62095c8$var$MID - 40} Z`,
            transform: `rotate(${angle.toFixed(1)} ${cx} ${$ed63a473d62095c8$var$MID})`,
            fill: index % 2 ? (0, $040sV.ACCENT) : 'currentColor',
            opacity: index % 2 ? 0.46 : 0.6
        }, {
            order: index,
            from: 'scale'
        }));
    }
    group.appendChild((0, $040sV.stroke)('circle', {
        cx: cx,
        cy: $ed63a473d62095c8$var$MID,
        r: 30,
        'stroke-width': 5
    }, {
        length: Math.round(2 * Math.PI * 30),
        order: blades
    }));
    return svg;
}
const $ed63a473d62095c8$export$7aa0ede0afd07d3a = {
    converge: $ed63a473d62095c8$var$converge,
    fracture: $ed63a473d62095c8$var$fracture,
    accumulate: $ed63a473d62095c8$var$accumulate,
    erode: $ed63a473d62095c8$var$erode,
    threshold: $ed63a473d62095c8$var$threshold,
    oscillate: $ed63a473d62095c8$var$oscillate,
    orbit: $ed63a473d62095c8$var$orbit,
    lattice: $ed63a473d62095c8$var$lattice,
    aperture: $ed63a473d62095c8$var$aperture
};

});
parcelRegister("040sV", function(module, exports) {

$parcel$export(module.exports, "BOX", function () { return $00c0bc4d8ea872c2$export$98e6811b31774aaa; });
$parcel$export(module.exports, "svgRoot", function () { return $00c0bc4d8ea872c2$export$4bc4b794fc0192a0; });
$parcel$export(module.exports, "bloom", function () { return $00c0bc4d8ea872c2$export$72ea7305df66deef; });
$parcel$export(module.exports, "organic", function () { return $00c0bc4d8ea872c2$export$499d362f626077ca; });
$parcel$export(module.exports, "plane", function () { return $00c0bc4d8ea872c2$export$35c1e6038505cb6; });
$parcel$export(module.exports, "stroke", function () { return $00c0bc4d8ea872c2$export$d9b706f8d0a70aef; });
$parcel$export(module.exports, "mark", function () { return $00c0bc4d8ea872c2$export$bf7f2fce5c1cf636; });
$parcel$export(module.exports, "spread", function () { return $00c0bc4d8ea872c2$export$3ae0fd4797ed47c8; });
$parcel$export(module.exports, "elementsFor", function () { return $00c0bc4d8ea872c2$export$df8759eb5e63ad86; });
$parcel$export(module.exports, "ACCENT", function () { return $00c0bc4d8ea872c2$export$6b1a2b07ad04beea; });
$parcel$export(module.exports, "COOL", function () { return $00c0bc4d8ea872c2$export$ce739723b0c5da78; });
$parcel$export(module.exports, "trianglePath", function () { return $00c0bc4d8ea872c2$export$56f1ad27feefd356; });
// Shared SVG construction. Motifs are drawn, never described: nothing in this
// directory writes markup, and no model-authored string ever reaches the DOM —
// a motif carries only a name, an intensity and a position.
//
// The vocabulary is deliberately Bauhaus: circle, square, triangle, bold flat
// planes, heavy/thin stroke contrast, asymmetric balance, and two colours from
// the palette overlapping so the translucency does the mixing. Atmosphere comes
// from a soft bloom behind the geometry, not from gradients inside it.
const $00c0bc4d8ea872c2$var$NS = 'http://www.w3.org/2000/svg';
const $00c0bc4d8ea872c2$export$98e6811b31774aaa = {
    width: 480,
    height: 260
};
let $00c0bc4d8ea872c2$var$idCounter = 0;
function $00c0bc4d8ea872c2$export$79a1817568da084b(prefix) {
    $00c0bc4d8ea872c2$var$idCounter += 1;
    return `atm-${prefix}-${$00c0bc4d8ea872c2$var$idCounter}`;
}
function $00c0bc4d8ea872c2$export$98bada23690e67eb(tag, attributes = {}) {
    const node = document.createElementNS($00c0bc4d8ea872c2$var$NS, tag);
    Object.entries(attributes).forEach(([name, value])=>node.setAttribute(name, String(value)));
    return node;
}
function $00c0bc4d8ea872c2$export$4bc4b794fc0192a0() {
    const svg = $00c0bc4d8ea872c2$export$98bada23690e67eb('svg', {
        viewBox: `0 0 ${$00c0bc4d8ea872c2$export$98e6811b31774aaa.width} ${$00c0bc4d8ea872c2$export$98e6811b31774aaa.height}`,
        preserveAspectRatio: 'xMidYMid meet',
        focusable: 'false',
        // Purely atmospheric: it carries no information a reader could miss.
        'aria-hidden': 'true'
    });
    return svg;
}
function $00c0bc4d8ea872c2$export$72ea7305df66deef(svg, { cx: cx, cy: cy, r: r, colour: colour = 'currentColor', opacity: opacity = 0.5 }) {
    const id = $00c0bc4d8ea872c2$export$79a1817568da084b('bloom');
    const defs = $00c0bc4d8ea872c2$export$98bada23690e67eb('defs');
    const filter = $00c0bc4d8ea872c2$export$98bada23690e67eb('filter', {
        id: id,
        x: '-50%',
        y: '-50%',
        width: '200%',
        height: '200%'
    });
    filter.appendChild($00c0bc4d8ea872c2$export$98bada23690e67eb('feGaussianBlur', {
        stdDeviation: Math.round(r / 2.6)
    }));
    defs.appendChild(filter);
    svg.appendChild(defs);
    const node = $00c0bc4d8ea872c2$export$98bada23690e67eb('circle', {
        cx: cx,
        cy: cy,
        r: r,
        fill: colour,
        filter: `url(#${id})`,
        opacity: opacity
    });
    node.classList.add('motif-bloom');
    svg.appendChild(node);
    return node;
}
function $00c0bc4d8ea872c2$export$499d362f626077ca(svg, { strength: strength = 3, frequency: frequency = 0.02, seed: seed = 3 } = {}) {
    const id = $00c0bc4d8ea872c2$export$79a1817568da084b('organic');
    const defs = $00c0bc4d8ea872c2$export$98bada23690e67eb('defs');
    const filter = $00c0bc4d8ea872c2$export$98bada23690e67eb('filter', {
        id: id,
        x: '-20%',
        y: '-20%',
        width: '140%',
        height: '140%'
    });
    filter.appendChild($00c0bc4d8ea872c2$export$98bada23690e67eb('feTurbulence', {
        type: 'fractalNoise',
        baseFrequency: frequency,
        numOctaves: 2,
        seed: seed,
        result: 'noise'
    }));
    filter.appendChild($00c0bc4d8ea872c2$export$98bada23690e67eb('feDisplacementMap', {
        in: 'SourceGraphic',
        in2: 'noise',
        scale: strength,
        xChannelSelector: 'R',
        yChannelSelector: 'G'
    }));
    defs.appendChild(filter);
    svg.appendChild(defs);
    const group = $00c0bc4d8ea872c2$export$98bada23690e67eb('g', {
        filter: `url(#${id})`
    });
    svg.appendChild(group);
    return group;
}
function $00c0bc4d8ea872c2$export$35c1e6038505cb6(tag, attributes = {}, { order: order = 0, from: from = 'up' } = {}) {
    const node = $00c0bc4d8ea872c2$export$98bada23690e67eb(tag, {
        fill: 'currentColor',
        ...attributes
    });
    node.classList.add('motif-plane');
    node.dataset.from = from;
    node.style.setProperty('--motif-order', String(order));
    return node;
}
function $00c0bc4d8ea872c2$export$d9b706f8d0a70aef(tag, attributes = {}, { length: length = 400, order: order = 0 } = {}) {
    const node = $00c0bc4d8ea872c2$export$98bada23690e67eb(tag, {
        fill: 'none',
        'stroke-linecap': 'butt',
        ...attributes
    });
    node.classList.add('motif-stroke');
    node.style.setProperty('--motif-length', String(length));
    node.style.setProperty('--motif-order', String(order));
    return node;
}
function $00c0bc4d8ea872c2$export$bf7f2fce5c1cf636(tag, attributes = {}, { order: order = 0 } = {}) {
    const node = $00c0bc4d8ea872c2$export$98bada23690e67eb(tag, {
        fill: 'currentColor',
        ...attributes
    });
    node.classList.add('motif-mark');
    node.style.setProperty('--motif-order', String(order));
    return node;
}
function $00c0bc4d8ea872c2$export$3ae0fd4797ed47c8(count, inset = 40) {
    if (count <= 1) return [
        $00c0bc4d8ea872c2$export$98e6811b31774aaa.width / 2
    ];
    const usable = $00c0bc4d8ea872c2$export$98e6811b31774aaa.width - inset * 2;
    return Array.from({
        length: count
    }, (_, index)=>inset + usable * index / (count - 1));
}
function $00c0bc4d8ea872c2$export$df8759eb5e63ad86(intensity, low, high) {
    const steps = [
        low,
        Math.round((low + high) / 2),
        high
    ];
    return steps[Math.max(0, Math.min(2, Number(intensity) - 1))] ?? steps[1];
}
const $00c0bc4d8ea872c2$export$6b1a2b07ad04beea = 'var(--atm-warm)';
const $00c0bc4d8ea872c2$export$ce739723b0c5da78 = 'var(--atm-cool)';
function $00c0bc4d8ea872c2$export$56f1ad27feefd356(cx, cy, size, rotation = 0) {
    const points = [
        0,
        120,
        240
    ].map((angle)=>{
        const radians = (angle + rotation) * Math.PI / 180;
        return `${(cx + Math.sin(radians) * size).toFixed(1)} ${(cy - Math.cos(radians) * size).toFixed(1)}`;
    });
    return `M${points.join(' L')} Z`;
}

});



//# sourceMappingURL=motifs.dc1ce46d.js.map
